import { conditionNavigator } from "./condition.navigator";
import { formActions } from "../../../../store/actions/cms/form/form.action";
import { conditionConstants } from "./condition.constants";
import { conditionTranslator } from "./condition.translator";
import { store } from "../../../../store/configureStore";
import { array } from "prop-types";
import { elementConstants } from "../../../../constants/cms/form/element/element.constants";


export const conditionHelper = {
  resolveCondition,
  extractElement,

  checkConditions,
  checkAll
};

function checkAll() {
  const form = store.getState().form;
  let targets = [];
  if (form && form.formElements) {
    let pageElements = form.formElements/* .filter(el => el.page == form.currentPage) */;
    pageElements.map(el => {
      if (
        el.data &&
        el.data.conditions &&
        el.data.conditions.length > 0
      ) {
        targets.push(el);
      }
    });
  }
  if (targets.length > 0) {
    targets.map(t => {
      let updatedElement = resolveQuery(t, form);
      store.dispatch(formActions.updateFormElement(updatedElement, true))
    });
  }

}
function checkConditions(sourceElementId) {
  const form = store.getState().form;
  let targets = [];
  if (form && form.formElements) {
    let pageElements = form.formElements/* .filter(el => el.page == form.currentPage) */;
    pageElements.map(el => {
      if (
        el.data &&
        el.data.conditions &&
        el.data.conditions.some(c => c.sourceId == sourceElementId)
      ) {
        targets.push(el);
      }
    });
  }
  if (targets.length > 0) {
    targets.map(t => {
      let updatedElement = resolveQuery(t, form);
      store.dispatch(formActions.updateFormElement(updatedElement, true))
    });
    //resolve
  }
};

function resolveQuery(targetElement, form) {
  let conditions = targetElement.data.conditions;
  //ALla conditions för det här target elementet
  //filtrerar alla conditons som inte är i grupp 0

  let queryStr = "";
  let conditionLists = {};
  for (const action in conditionConstants.actions) {
    if (conditionConstants.actions.hasOwnProperty(action)) {
      conditionLists[conditionConstants.actions[action]] = conditions.filter(el => el.action == conditionConstants.actions[action]);
    }
  }
  let updatedElement = Object.assign({}, targetElement);
  updatedElement.data = Object.assign({}, targetElement.data);
  updatedElement.props = Object.assign({}, targetElement.props);
  for (const action in conditionLists) {
    if (conditionLists.hasOwnProperty(action)) {
      if (conditionLists[action] && conditionLists[action].length > 0) {
        conditionLists[action].sort((a, b) => { return a.sortOrder - b.sortOrder; }).map(c => {
          if (c.prefix) queryStr += " " + c.prefix.replace("AND", "&&").replace("OR", "||") + " ";
          queryStr += resolveCondition(c, form);
          if (c.suffix) queryStr += " " + c.suffix.replace("AND", "&&").replace("OR", "||") + " ";
        });
        let result = eval(queryStr);
        updatedElement = executeAction(action, updatedElement, result);
      }
    }
  }
  return updatedElement;
};

//Foreach condition
function resolveCondition(condition, form) {
  const sourceElement = extractElement(form, condition.sourceId);
  let isMet = false;
  let conditionStr = "";
  if (sourceElement) {
    const sourceValue = conditionNavigator.navigate(sourceElement);
    if (Array.isArray(sourceValue) || condition.operator === conditionConstants.operators.LIKE) {
      conditionStr = resolveCheckboxCondition(sourceValue, condition);
    } else {
      conditionStr = `('${sourceValue}' ${conditionTranslator.translateOperator(
        condition.operator
      )} '${condition.value}')`;
    }
  }
  return conditionStr;
};

function resolveCheckboxCondition(sourceValue, condition) {
  let cStr = "";
  if (condition.operator == conditionConstants.operators.ANY && sourceValue.length > 0) {
    cStr = "(true)";
  }
  else if (condition.operator == conditionConstants.operators.LIKE && sourceValue && sourceValue.toString().includes(condition.value)) {
    cStr = "(true)";
  }
  else if (condition.operator == conditionConstants.operators.EQUAL) {
    cStr = `(${sourceValue.some(sv => sv.optionId == condition.value)})`;
  } else if (condition.operator == conditionConstants.operators.NOT_EQUAL) {
    cStr = `(${!sourceValue.some(sv => sv.optionId == condition.value)})`;
  } else if (condition.operator == conditionConstants.operators.LESS_THAN_OR_EQUAL_TO) {
    cStr = `(${sourceValue.length <= condition.value})`;
  } else if (condition.operator == conditionConstants.operators.GREATER_THAN_OR_EQUAL_TO) {
    cStr = `(${sourceValue.length >= condition.value})`;
  }
  else {
    cStr = "(false)"
  }
  return cStr;


}

function extractElement(form, elementId) {
  const sourceElement = form.formElements.find(fe => {
    return fe.formElementId === elementId;
  });
  return sourceElement;
};
/* function validateElement(targetElement) {
  if (targetElement.data.hidden !== !value) {
    if (!value === true) {
      targetElement.isValid = true;
      if (targetElement.type === elementConstants.QUESTION
        && targetElement) {
        targetElement.props.options.map(o => {
          o.isSelected = false;
        })
        targetElement.props.text = "";
      }
      if (targetElement.type === elementConstants.FIELD
        && targetElement) {
        targetElement.props.text = "";
      }
      if (targetElement.type === elementConstants.EVENT
        && targetElement) {
        targetElement.props.isSelected = false;
      }
    }
    else {
      targetElement.isValid = false;
    }
  }
  return targetElement
} */
function executeAction(action, targetElement, value) {
  switch (action) {
    case conditionConstants.actions.Show:

      if (targetElement.data.hidden !== !value) {
        if (!value === true) {
          targetElement.isValid = true;
          if (targetElement.type === elementConstants.QUESTION
          ) {
            if (targetElement.props.type === 'Option') {
              targetElement.props.options.map(o => {
                o.isSelected = false;
              })
            }
            targetElement.props.text = "";
          }
          if (targetElement.type === elementConstants.FIELD
          ) {
            targetElement.props.text = "";
          }
          if (targetElement.type === elementConstants.EVENT
          ) {
            targetElement.props.isSelected = false;
            store.dispatch(formActions.removeOrderByCondition(targetElement.id));
         
          }
        }
        else {
          targetElement.isValid = false;
        }
      }

      targetElement.data.hidden = !value;

      break;
    case conditionConstants.actions.Require:
      targetElement.data.required = value;
      break;
    case conditionConstants.actions.ReadOnly:
      targetElement.data.readOnly = value;
    case conditionConstants.actions.CustomError:
      break;
    default:
      break;
  }
  return targetElement;
};
